/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useRef } from "react";
import "./install-progress.css";
import Hand from "../../assets/svg/Hand.svg";
import RightIcon from "../../assets/svg/RightIcon.svg";
import { IconButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { WORKSPACE_REDIRECT_TIMEOUT } from "../../constants/common";
import SMSMagicSvg from "../../assets/svg/SMS-Magic.svg";
import SalesforceImg from "../../assets/svg/Salesforce_logo_img.svg.png";
import {
  ABORT_API,
  // eslint-disable-next-line no-unused-vars
  CANCEL_PAGE_TIMEOUT,
  SF_INSTALL_API,
} from "../../constants/common";
import CancelIcon from "../../assets/svg/Cancel.svg";
// import PermissionDenied from "./permission-denied";
import ShimmerEffect from "./ShimmerEffect";
import PermissionDeniedInstall from "./permission-denied-install";
import DataCenter from "./DataCenter";
import SessionExpired from "./SessionExpired";
import ConfirmationDialog from "./ConfirmationDialog";

export default function InstallProgress({ state }) {
  const [responseSignUp, setResponseSignUp] = useState({});
  const [error, setError] = useState(false);
  const [cancelShow, setCancelShow] = useState(false);
  const queryStr = state?.queryStr;

  const intervalIdRef = useRef(null);
  let intervalCancel;
  // eslint-disable-next-line no-unused-vars
  const [isCancelButtonClicked, setIsButtonCancelClicked] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [countdownCancel, setCountdownCancel] = useState(null);
  const [countdown, setCountdown] = useState(null);
  const [permissionDenied, setPermissionDenied] = useState(false);
  const [loadingShimmer, setLoadingShimmer] = useState(true);
     // eslint-disable-next-line no-unused-vars
  const [isDataCenterChanged,setIsDataCenterChanged]=useState(state?.skip_data_center_check);
  const [isSessionExpired,setIsSessionExpired]=useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);


  // const disabledButtonStyle2 = {
  //   color: 'black', // Your desired "disabled" color
  //   borderColor: '#9E9E9E', // Match border color with text color
  //   '&:hover': {
  //     borderColor: '#9E9E9E', // Maintain border color on hover
  //     backgroundColor: 'transparent', // Remove background color on hover
  //   },
  // };

  const handleCancel = async () => {
    // setIsButtonCancelClicked(true);

    if (!showConfirmation) {
      setShowConfirmation(true);
      clearInterval(intervalIdRef.current);
      return;
    }

    setShowConfirmation(false);

    let baseUrl = `${window.location.protocol}//${window.location.host}`;
    let url = `${baseUrl}${ABORT_API}`;
    let res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
    // let resJson = await res.json();
    if (res.status === 200) {
      clearInterval(intervalIdRef.current);

      // setCountdownCancel(CANCEL_PAGE_TIMEOUT);
      // intervalCancel = setInterval(() => {
      //   setCountdownCancel((prev) => {
      //     if (prev === 1) {
      //       clearInterval(intervalCancel);
      //       window.location.replace(
      //         `${process.env.REACT_APP_LANDING_PAGE_BASE_URL}workspace`
      //       );
      //       return 0;
      //     }
      //     return prev - 1;
      //   });
      // }, 1000);
      window.location.replace(
        `${process.env.REACT_APP_LANDING_PAGE_BASE_URL}workspace`
      );
    } else {
      alert("SOMETHING WENT WRONG");
    }
  };

  const callSFInstall = async (account_id) => {
    let baseUrl = `${window.location.protocol}//${window.location.host}`;
    let url = `${baseUrl}${SF_INSTALL_API}`;
    let payload = { account_id };

    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    // let resJson = await res.json();
    if (res.status === 200) {
      window.location.replace(
        `${process.env.REACT_APP_LANDING_PAGE_BASE_URL}workspace`
      );
    } else if (res.status === 403) {
      setPermissionDenied(true);
    }else if(res.status===500){
      setIsSessionExpired(true);
    }
    
    else {
      alert("SOMETHING WENT WRONG");
    }
  };

  /* eslint-disable eqeqeq */
  useEffect(() => {
    if(state?.skip_data_center_check!=true){    
      callSignupAPI();
    }else{
      setLoadingShimmer(false);
    }
    
    return () => {
      clearInterval(intervalIdRef.current);
      clearInterval(intervalCancel);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  /* eslint-enable eqeqeq */

 

  const callSignupAPI = async (type="") => {
    let signupUrl = `${process.env.REACT_APP_SOCIAL_API}?${queryStr}`;
    let res = await fetch(signupUrl, {
      method: "GET",
    });
    let resJson = await res.json();
    //Dummy Data for Testing on Local
    // const resJson = {
    //   // account_exists: false,
    //   // package_installed: false,
    // }
    setLoadingShimmer(false);
    setResponseSignUp(resJson);
    console.log('resJson',resJson);

    if (res.status === 200) {

      localStorage.setItem("stories_delight", resJson.access_token);
      localStorage.setItem("hideBullhorn", "false");
      setCancelShow(true);

      setCountdown(WORKSPACE_REDIRECT_TIMEOUT);
      intervalIdRef.current = setInterval(async () => {
        setCountdown((prev) => {
          if (prev === 1) {
            clearInterval(intervalIdRef.current);
            callSFInstall(resJson.account_id);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    

    } else if (res.status === 409) {

      if(type=="continueWorkspace"){  // eslint-disable-line eqeqeq
        localStorage.setItem("stories_delight", resJson.access_token);
        localStorage.setItem("hideBullhorn", "false");
        console.log('redirecting to workspcase')
        window.location.replace(
          `${process.env.REACT_APP_LANDING_PAGE_BASE_URL}workspace`
        );
        return
      }

      if(resJson?.data_center){
        console.log('in data center',resJson);
        // setIsDataCenterChanged(true)
        // if(resJson?.data_center =="us"){
        //   https://aus-app.sms-magic.com/trial/salesforce/authorize
        // }
        // let dataCenter=resJson?.data_center;
        let dataCenter = resJson?.data_center?.toUpperCase();
      
        let SALESFORCE_CONFIG;
        let rawConfig = process.env.REACT_APP_SALESFORCE_CONFIG;
        // eslint-disable-next-line eqeqeq
        if (dataCenter == "US") {
            console.log("In US Data Center");
            rawConfig = process.env.REACT_APP_SALESFORCE_CONFIG_US;
            // eslint-disable-next-line eqeqeq
        } else if (dataCenter == "EU") {
            console.log("In EU Data Center");
            rawConfig = process.env.REACT_APP_SALESFORCE_CONFIG_EU;
            // eslint-disable-next-line eqeqeq
        } else if (dataCenter == "AUS") {
            console.log("In AUS Data Center");
            rawConfig = process.env.REACT_APP_SALESFORCE_CONFIG_AUS;
        }

        if (dataCenter == "INTG") {  // eslint-disable-line eqeqeq
          console.log("In INTEGRATION Data Center");
          rawConfig = process.env.REACT_APP_SALESFORCE_CONFIG_INTG;
          // eslint-disable-next-line eqeqeq
      } else if (dataCenter == "QA") {
          console.log("In QA Data Center");
          rawConfig = process.env.REACT_APP_SALESFORCE_CONFIG_QA;
          // eslint-disable-next-line eqeqeq
      } else if (dataCenter == "STAGING") {
          console.log("In STAGING Data Center");
          rawConfig = process.env.REACT_APP_SALESFORCE_CONFIG_STAG;
      }

        try {
            // eslint-disable-next-line no-useless-escape
            const decodedConfig = rawConfig.replace(/\\\"/g, '"').replace(/\\\\/g, '\\');
            SALESFORCE_CONFIG = JSON.parse(decodedConfig);
        } catch (error) {
            alert('Something went wrong')
            console.error("Error parsing SALESFORCE_CONFIG:", error);
            window.history.back();
            return;
        }
        const prod = SALESFORCE_CONFIG.salesforceProd;
        // const sandbox = SALESFORCE_CONFIG.salesforceSandbox;
        let socialProvider=state?.org_type;
        let code=resJson?.code;
        let action=state?.action;
        let account_exists=resJson?.account_exists;
        let package_installed=resJson?.package_installed;
       
        
        const new_state = `org_type=${socialProvider}&source=app_exchange&dataCenter=${dataCenter}&action=${action}&account_exists=${account_exists}&package_installed=${package_installed}&skip_data_center_check=true`;
        console.log("state in sso url is-------->", state);
      
        let url=`${prod.params.redirect_uri}/?code=${code}&state=${encodeURIComponent(new_state)}`
        // if (socialProvider === 'production') {
         
        //     ssoUrl = `${prod.oauth2Endpoint}?response_type=${prod.params.response_type}&client_id=${encodeURIComponent(prod.params.client_id)}&redirect_uri=${encodeURIComponent(prod.params.redirect_uri)}&&state=${encodeURIComponent(state)}`;
        // } else {
        //     ssoUrl = `${sandbox.oauth2Endpoint}?response_type=${sandbox.params.response_type}&client_id=${encodeURIComponent(sandbox.params.client_id)}&prompt=login&redirect_uri=${encodeURIComponent(sandbox.params.redirect_uri)}&state=${encodeURIComponent(state)}`;
        // }
        window.parent.location.href = url;

      }
      else{

        localStorage.setItem("stories_delight", resJson.access_token);
        localStorage.setItem("hideBullhorn", "false");
        setCancelShow(true);
        setCountdown(WORKSPACE_REDIRECT_TIMEOUT);
        intervalIdRef.current = setInterval(async () => {
          setCountdown((prev) => {
            if (prev === 1) {
              clearInterval(intervalIdRef.current);
              (async () => {
                if (resJson?.account_exists && resJson?.package_installed) {
                  window.location.replace(
                    `${process.env.REACT_APP_LANDING_PAGE_BASE_URL}workspace`
                  );
                } else {
                  await callSFInstall(resJson.account_id);
                }
              })();

              return 0;
            }
            return prev - 1;
          });
        }, 1000);
      }
    } else if (res.status === 400) {
      setError(true);
    }else if(res.status===500){
      setIsSessionExpired(true)
    } 
    else {
      setError(true);
    }
  };

  const handleRetry = () => {
    if (window.location.hostname.includes("txtbox")) {
      window.location.replace(
        `${process.env.REACT_APP_BASE_API_URL}/salesforce/setup`
      );
    } else {
      window.location.replace("https://app.sms-magic.com/salesforce/setup");
    }
  };

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
    intervalIdRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) {
          clearInterval(intervalIdRef.current);
          callSFInstall(responseSignUp.account_id);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  return (<>
    {loadingShimmer ? (
      <ShimmerEffect/>
    ) : 
     isSessionExpired ? <SessionExpired/> :(
    
    <div className="installation-container">
      {!loadingShimmer && <header style={{ padding: "20px" }} className="header">
        <div className="flex items-center gap-2">
          <a href="/salesforce/setup" className="magic-logo">
            <img
              src="https://sm-icon-assets.s3.us-east-1.amazonaws.com/sms-magic-logo.svg"
              alt="logo"
              style={{ height: "24px", width: "143.3px" }}
            ></img>
          </a>
        </div>
      </header>}
      {isDataCenterChanged?(
        <DataCenter state={state} callSignupAPI={callSignupAPI}/>

      )
      :
      permissionDenied? (<PermissionDeniedInstall />):(
      isCancelButtonClicked ? (
        <main className="main-content-cancel">
          <div className="icon-container">
            <img src={SMSMagicSvg} alt="SMS-Magic Icon" className="icon-sms" />
            <div className="dotted-line-red" />

            <div>
              <img src={CancelIcon} alt="cancel Icon" className="cancel-icon" />
            </div>

            <div className="dotted-line-red" />

            <div className="salesforce-logo-container">
              <img
                src={SalesforceImg}
                alt="Salesforce Logo"
                className="salesforce-logo"
              />
            </div>
          </div>

          {/* Installation Text */}
          <div className="installation-text">
            <h1 className="title title-red">
              SMS Magic package installation cancelled
            </h1>
          </div>

          {/* Info Box */}
          <div className="info-box-cancel">
            {/* <Info className="info-icon" /> */}
            <IconButton style={{ padding: "0px" }}>
              <InfoIcon style={{ padding: "0px", color: "#AEB0B1" }} />
            </IconButton>
            <span className="info-text">
              SMS Magic account was created. You can resume installation there
              when ready.
            </span>
          </div>

          {/* <Button variant="outlined" sx={disabledButtonStyle2} >Go to workspace</Button> */}
          {countdownCancel !== null && (
            <div className="workspace-redirect">
              Redirecting to workspace in{" "}
              <span className="timer">{countdownCancel} seconds</span>
            </div>
          )}
        </main>
      ) : (
        <main className="main-content">
          { !responseSignUp?.data_center &&
          <div className="icon-container">
            <img src={SMSMagicSvg} alt="SMS-Magic Icon" className="icon" />

            {error ? <div className="dotted-line-red" /> :<div className="dotted-line" />}

            <div>
              <img
                src={
                  responseSignUp?.account_exists &&
                  responseSignUp?.package_installed
                    ? RightIcon : error ? CancelIcon
                    : Hand
                }
                alt={
                  responseSignUp?.account_exists &&
                  responseSignUp?.package_installed
                    ? "Right Icon" : error ? "Cancel"
                    : "Hand Icon"
                }
                className={
                  responseSignUp?.account_exists &&
                  responseSignUp?.package_installed
                    ? "right-icon" : error ? "cancel-icon"
                    : "hand"
                }
              />
            </div>

            {error ? <div className="dotted-line-red" /> :<div className="dotted-line" />}

            <div className="salesforce-logo-container">
              <img
                src={SalesforceImg}
                alt="Salesforce Logo"
                className="salesforce-logo"
              />
            </div>
          </div>
          }
          {responseSignUp?.account_exists &&
          responseSignUp?.package_installed && !("data_center" in responseSignUp) &&
          !error 
          ? (
            <div className="installation-text" style={{ marginBottom: "30px" }}>
              <h1 className="title">
                SMS Magic packages are already installed
              </h1>
              <h2 className="subtitle"> on this account</h2>
            </div>
          ) : (
            <div className="installation-text-hero">
              {error ? (
                <div>
                  <h1 className="title">
                  Sign Up process failed.
                </h1>
                <p className="subtitle-magic">
                  Please try again or contact support if the issue persists.
                </p>
                </div>
              ) : (
                <>
                {!responseSignUp?.data_center && 
                  <h1 className="title">Setup in progress</h1>
                }
                </>
              )}
              {!error && !responseSignUp?.data_center && (
                <p className="subtitle-magic">
                  Your SMS Magic package is being installed and configured now.
                </p>
              )}
            </div>
          )}

          {responseSignUp?.account_exists &&
          !responseSignUp?.package_installed && !responseSignUp?.data_center  ? (
            <div className="info-box-cancel">
              <IconButton style={{ padding: "0px" }}>
                <InfoIcon style={{ padding: "0px", color: "#AEB0B1" }} />
              </IconButton>
              <span className="info-text">
                You already have an account on SMS Magic
              </span>
            </div>
          ) : !responseSignUp?.account_exists &&
            !responseSignUp?.package_installed && !error? (
            <div className="info-box-cancel">
              <IconButton style={{ padding: "0px" }}>
                <InfoIcon style={{ padding: "0px", color: "#AEB0B1" }} />
              </IconButton>
              <span className="info-text">
                An Account is being created on SMS Magic
              </span>
            </div>
          ) : null}

          {responseSignUp?.account_exists &&
          responseSignUp?.package_installed &&
          !error ? (
            <div className="cancel-link">
              {countdown !== null && (
                <div className="workspace-redirect">
                  Redirecting to workspace in{" "}
                  <span className="timer">{countdown} seconds</span>
                </div>
              )}
            </div>
          ) : error ? (
            <div className="error-cta">
              <div className="error-cta" style={{padding:'10px'}}>
                <button className="retry-signup" onClick={handleRetry}>
                  Retry Sign-Up
                </button>
              </div>
              <div className="error-cta">
                <span>
                  Contact:{" "}
                  <a href="mailto:care@screen-magic.com">care@screen-magic.com</a>
                </span>
              </div>
            </div>
          ) : (
            <>{
              !responseSignUp?.data_center && 
              <div
              className="cancel-link"
              style={{ marginBottom: "20px", marginTop: "20px" }}
            >
              Do you want to cancel installation?{" "}
              <a
                href="#"
                onClick={handleCancel}
                className={
                  cancelShow ? "cancel-link-text" : "cancel-link-text-disabled"
                }
              >
                Cancel
              </a>
            </div>
            }

            {showConfirmation && 
              <ConfirmationDialog 
                onClose={handleCloseConfirmation}
                onConfirm={() => handleCancel()}
                type="install"
              />
            }
            
            </>
          )}

          {!responseSignUp?.package_installed &&
            !error &&
            countdown !== null && (
              <div
                className="workspace-redirect"
                style={{ marginBottom: "20px", marginTop: "20px" }}
              >
                Redirecting to workspace in{" "}
                <span className="timer">{countdown} seconds</span>
              </div>
            )}
        </main>
      ))}
    </div>
   )
      }
      </>
  );
}
